import { render, staticRenderFns } from "./HomePageContentIBZ.vue?vue&type=template&id=6815d6ba&scoped=true"
import script from "./HomePageContentIBZ.vue?vue&type=script&lang=ts"
export * from "./HomePageContentIBZ.vue?vue&type=script&lang=ts"
import style0 from "./HomePageContentIBZ.vue?vue&type=style&index=0&id=6815d6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815d6ba",
  null
  
)

export default component.exports